<script setup lang="ts">
import { useTypesEdgesModel } from './../model/model.ts'
import { VModal } from '@/shared/ui'
import { useRoute } from 'vue-router'
import { ref } from 'vue'
import TypesEdgesFields from './tabs/TypesEdgesFields.vue'
import TypesSumFields from './tabs/TypesSumFields.vue'

const route = useRoute()
const objectId = ref(route.params.object_id as string)

const emits = defineEmits(['save'])

const model = useTypesEdgesModel()
const { isLoading } = model.loadType(objectId)

const tab = ref<string>('fields')

/**
 * Функция сохранения изменений
 */
const saveHandler = () => {
  model.open = false

  emits('save', model.item)
}
</script>

<template>
  <VModal v-model="model.open" :title="$t('itf.object_types_edges_edit')" :width="1400">
    <VTabs v-model="tab">
      <VTab value="fields">Поля</VTab>
      <VTab value="sum_fields">Сводная информация</VTab>
    </VTabs>

    <VTabsWindow v-model="tab">
      <VTabsWindowItem value="fields">
        <TypesEdgesFields :isLoading />
      </VTabsWindowItem>

      <VTabsWindowItem value="sum_fields">
        <TypesSumFields />
      </VTabsWindowItem>
    </VTabsWindow>

    <div class="form__btn_right mt-2">
      <VBtn @click="saveHandler">
        {{ $t('itf.save') }}
      </VBtn>

      <VBtn color="default" @click="model.open = false">
        {{ $t('itf.cancel') }}
      </VBtn>
    </div>
  </VModal>
</template>
